import { Component, inject, Input, OnInit, OnDestroy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ClockComponent } from '@shared/components/layout/headers/clock/clock.component';
import { AuthService } from '@services/auth/auth.service';
import { ActivatedRoute, Router, RouterModule, NavigationEnd } from '@angular/router';
import { StrHeaderSelectorComponent } from '../str-header-selector/str-header-selector.component';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { LanguageService } from "@services/language/language.service";
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { NotificationsMenuComponent } from "../notifications-menu/notifications-menu.component";
import { SidebarComponent } from '@shared/components/layout/sidebar/sidebar.component';
import { UserMenuComponent } from "../user-menu/user-menu.component";
import { ApiSysService } from '@services/api/api-sys.service';
import { VoipCallComponent } from '../voip-call/voip-call.component';
import { CallState, VoipService } from '@core/services/websockets/voip/voip.service';

@Component({
    selector: 'app-logged-header',
    imports: [ClockComponent, StrHeaderSelectorComponent, LanguageSelectorComponent, RouterModule, NotificationsMenuComponent, SidebarComponent, UserMenuComponent, VoipCallComponent],
    templateUrl: './logged-header.component.html',
    styleUrl: './logged-header.component.scss'
})

export class LoggedHeaderComponent implements OnInit, OnDestroy {
  @Input() strListBool!: boolean;
  @Input() textHeader!: string;
  user: any;
  role: any;
  alert: any;
  imgAlert: any = 'assets/icons/header/alarm.svg';

  private readonly voipService = inject(VoipService);
  protected readonly voipCallState = toSignal(this.voipService.callState$, { initialValue: 'idle' as CallState });
  translateData: any;
  translatedHeader: string = '';
  preferredUrl: string | undefined;

  private routerSubscription: Subscription | undefined;
  private destroy$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private languageService: LanguageService,
    private apiSysService: ApiSysService
  ) {
    const userId = this.authService.getUserId();
    if (!userId) {
      this.preferredUrl = '/landing';
    } else {
      this.apiSysService.getPersonnelPreferences(userId).subscribe({
        next: (preferences) => {
          this.preferredUrl = preferences?.preferred_url ?? '/landing';
        },
        error: () => {
          this.preferredUrl = '/landing';
        }
      });
    }
  }

  private loadTranslations() {
    this.languageService.getSharedDictionary("header").subscribe(async (data) => {
      this.translateData = await data;
      this.translateHeader();
    });
  }

  private translateHeader() {
    if (this.translateData && this.textHeader) {
      const headerKey = this.textHeader.toLowerCase().replace(/\s+>\s+/g, '_').replace(/\s+/g, '_');

      if (this.translateData[headerKey]) {
        this.translatedHeader = this.translateData[headerKey];
      } else {
        this.translatedHeader = this.textHeader;
      }
    } else {
      this.translatedHeader = this.textHeader || '';
    }
  }

  async ngOnInit() {
    const userData = this.authService.userValue;
    if (!userData) return;
    this.user = userData.personnel.per_user;
    this.role = userData.personnel.rolenameArray?.[0] ?? '';
    this.loadTranslations();

    this.authService.profileUpdated$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        const userId = this.authService.getUserId();
        if (userId) {
          this.apiSysService.getPersonnelPreferences(userId).subscribe({
            next: (preferences) => {
              this.preferredUrl = preferences?.preferred_url ?? '/landing';
            },
            error: () => {
              this.preferredUrl = '/landing';
            }
          });
        }
      });

    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      let currentRoute = this.route;
      while (currentRoute.firstChild) {
        currentRoute = currentRoute.firstChild;
      }

      currentRoute.data.subscribe(data => {
        if (data['headerTitle']) {
          this.textHeader = data['headerTitle'];
          this.loadTranslations();
        }
      });
    });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
  isInVideoPlayer(){
    return this.router.url.includes('/video');
  }
}